import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { openCookieSettings } from "@/lib/consent";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-[#3B4157] bg-[#252937] mt-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12 grid gap-8 md:grid-cols-3">
        <div>
          <div className="font-display font-black text-2xl uppercase">Sėdynės<span className="text-orange-500">.lt</span></div>
          <p className="text-sm text-slate-400 mt-3 max-w-xs">{t("footer_text")}</p>
        </div>
        <div className="text-sm text-slate-400 space-y-2">
          <Link to="/catalog" className="block hover:text-orange-500">{t("nav_catalog")}</Link>
          <Link to="/sedynes/grammer" className="block hover:text-orange-500">Grammer</Link>
          <Link to="/sedynes/proboss" className="block hover:text-orange-500">Proboss</Link>
          <Link to="/sedynes/total-source" className="block hover:text-orange-500">Total Source</Link>
          <Link to="/seat-finder" className="block hover:text-orange-500">{t("nav_finder")}</Link>
          <Link to="/admin" data-testid="footer-admin-link" className="block hover:text-orange-500">{t("nav_admin")}</Link>
        </div>
        <div data-testid="footer-contacts" className="text-sm text-slate-400 space-y-1">
          <div className="text-slate-200 font-semibold">MB „Mtechos prekyba“</div>
          <a href="tel:+37064284410" data-testid="footer-phone" className="block font-mono-x hover:text-orange-500 pt-2">+370 642 84410</a>
          <a href="mailto:prekyba@mtech.lt" data-testid="footer-email" className="block font-mono-x hover:text-orange-500">prekyba@mtech.lt</a>
          <div className="pt-3 text-xs text-slate-400">© {new Date().getFullYear()} Sėdynės.lt</div>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 pb-8 flex flex-wrap gap-x-6 gap-y-2 text-xs text-slate-500">
        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-orange-500">{t("privacy")}</Link>
        <Link to="/cookies" data-testid="footer-cookies-link" className="hover:text-orange-500">{t("cookies_policy")}</Link>
        <Link to="/terms" data-testid="footer-terms-link" className="hover:text-orange-500">{t("terms")}</Link>
        <Link to="/traktoriu-sedynes" data-testid="footer-brands-link" className="hover:text-orange-500">{t("bp_index_title")}</Link>
        <Link to="/delivery" data-testid="footer-delivery-link" className="hover:text-orange-500">{t("delivery_returns")}</Link>
        <button data-testid="footer-cookie-settings-btn" onClick={openCookieSettings} className="hover:text-orange-500">{t("cookie_settings")}</button>
      </div>
    </footer>
  );
}
